
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexSUMeh0PyVJe_45g_uH76Iq3X0aNkZY6QbNdqe1qv4FY9QMeta } from "/opt/build/repo/pages/development/index.vue?macro=true";
import { default as _91slug_93o_rNWxCYdySfd8lv33jS2tTyqy8wPzP9pm_45GA2gPBZYMeta } from "/opt/build/repo/pages/development/[slug].vue?macro=true";
import { default as _91slug_93h45y02Hkxo0xuNb3yWM29dlF0k_ZMvipv6dDy7l_g98Meta } from "/opt/build/repo/pages/development/news/[slug].vue?macro=true";
import { default as _91slug_93jta2yK940BBAmYGht5fwoYchIt_l5M3U98qM8kzWD8gMeta } from "/opt/build/repo/pages/development/projects/[slug].vue?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/",
    meta: indexSUMeh0PyVJe_45g_uH76Iq3X0aNkZY6QbNdqe1qv4FY9QMeta || {},
    component: () => import("/opt/build/repo/pages/development/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexSUMeh0PyVJe_45g_uH76Iq3X0aNkZY6QbNdqe1qv4FY9QMeta || {},
    component: () => import("/opt/build/repo/pages/development/index.vue")
  },
  {
    name: "slug___en",
    path: "/:slug()",
    meta: _91slug_93o_rNWxCYdySfd8lv33jS2tTyqy8wPzP9pm_45GA2gPBZYMeta || {},
    component: () => import("/opt/build/repo/pages/development/[slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug()",
    meta: _91slug_93o_rNWxCYdySfd8lv33jS2tTyqy8wPzP9pm_45GA2gPBZYMeta || {},
    component: () => import("/opt/build/repo/pages/development/[slug].vue")
  },
  {
    name: "news-slug___en",
    path: "/news/:slug()",
    meta: _91slug_93h45y02Hkxo0xuNb3yWM29dlF0k_ZMvipv6dDy7l_g98Meta || {},
    component: () => import("/opt/build/repo/pages/development/news/[slug].vue")
  },
  {
    name: "news-slug___nl",
    path: "/nl/nieuws/:slug()",
    meta: _91slug_93h45y02Hkxo0xuNb3yWM29dlF0k_ZMvipv6dDy7l_g98Meta || {},
    component: () => import("/opt/build/repo/pages/development/news/[slug].vue")
  },
  {
    name: "projects-slug___en",
    path: "/projects/:slug()",
    meta: _91slug_93jta2yK940BBAmYGht5fwoYchIt_l5M3U98qM8kzWD8gMeta || {},
    component: () => import("/opt/build/repo/pages/development/projects/[slug].vue")
  },
  {
    name: "projects-slug___nl",
    path: "/nl/projects/:slug()",
    meta: _91slug_93jta2yK940BBAmYGht5fwoYchIt_l5M3U98qM8kzWD8gMeta || {},
    component: () => import("/opt/build/repo/pages/development/projects/[slug].vue")
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl/en",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/team",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl/team",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/about-us",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl/about-us",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/our-projects",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl/our-projects",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/team/bastiaan-bor",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl/team/bastiaan-bor",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/team/bjorn-konink",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl/team/bjorn-konink",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/team/matthijs-de-haan",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl/team/matthijs-de-haan",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  }
]